import { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import FocusTrap from "focus-trap-react";
import cn from "classnames";
import useMountTransition from "./useMountTransition";
import "./Drawer.scss";
import useWindowSize from "../../hooks/useWindowSize";
import { isNumber, isString } from "lodash";

// function createPortalRoot() {
//   const root=  document.getElementById("root-container");
//   const drawerRoot = document.createElement("div");
//   drawerRoot.setAttribute("id", "drawer-root");
//   root.appendChild(root)
//   return drawerRoot;
// }

/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/building-a-drawer-component-with-react-portals
 */
const Drawer = ({
  isOpen,
  children,
  className,
  onClose,
  position = "bottom",
  removeWhenClosed = true,
  height,
  onScroll,
  fixedChildren,
}) => {
  const isTransitioning = useMountTransition(isOpen, 300);
  const { width, height: heightWindow } = useWindowSize();
  const [startY, setStartY] = useState();
  const [endY, setEndY] = useState();
  // Append portal root on mount
  useEffect(() => {
    return () => {
      // Clean up the portal when drawer component unmounts
      // document.getElementById("drawer-container")?.remove();
      // Ensure scroll overflow is removed
      document.body.style.overflow = "";
    };
  }, []);

  // Prevent page scrolling when the drawer is open
  useEffect(() => {
    const updatePageScroll = () => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    };

    updatePageScroll();
  }, [isOpen]);

  // Allow Escape key to dismiss the drawer
  useEffect(() => {
    const onKeyPress = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keyup", onKeyPress);
    }

    return () => {
      window.removeEventListener("keyup", onKeyPress);
    };
  }, [isOpen, onClose]);
  const [test, setTest] = useState(height);
  useEffect(() => {
    if (height == "auto" || height < heightWindow) {
      if (startY > endY) {
      } else if (startY < endY) {
        onClose();
      }
    }
  }, [endY]);
  if (!isTransitioning && removeWhenClosed && !isOpen) {
    return null;
  }
  return createPortal(
    <div className="drawer-style ">
      {" "}
      <FocusTrap active={isOpen}>
        <div
          aria-hidden={isOpen ? "false" : "true"}
          className={cn("drawer-container", {
            open: isOpen,
            in: isTransitioning,
            className,
          })}
        >
          <div
            className={`position-fixed bottom-0 `}
            style={{
              zIndex: "1002",
              width: width > 600 ? "600px" : "100%",
            }}
          >
            {fixedChildren}
          </div>
          <div
            className={cn("drawer", position)}
            onScroll={onScroll}
            role="dialog"
            style={{
              height: height,
              // height: isNumber(height)
              //   ? heightWindow > height
              //     ? `${height}px`
              //     : `${heightWindow - 1}px`
              //   : height,
              overflow: "auto",
            }}
          >
            <button
              className="d-flex btn p-0 w-100 text-decoration-none drawer-button"
              style={{ cursor: "context-menu" }}
              draggable
              // onDragStart={(e) => setStartY(e.clientY)}
              // onDragEnd={(e) => setEndY(e.clientY)}
              onTouchStart={(e) => {
                setStartY(e.targetTouches[0].clientY);
              }}
              onTouchMove={(e) => {
                setEndY(e.targetTouches[0].clientY);
              }}
            >
              <svg
                className="mr-x-auto mr-t-6"
                width="79"
                height="4"
                viewBox="0 0 79 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="79" height="4" rx="2" fill="#D1D5DB" />
              </svg>
            </button>

            {children}
          </div>
          <div className="backdrop" onClick={onClose} />
        </div>
      </FocusTrap>
    </div>,
    document.getElementById("drawer-container")
  );
};

export default Drawer;
